/**
 * CocktailBox — EUR → BGN price converter
 * Detects EUR prices on the page and appends BGN equivalent in parentheses.
 * Format: €119,00 EUR → €119,00 EUR (232,74 лв.)
 * Uses MutationObserver for dynamic content (cart drawer, AJAX updates).
 */

(function () {
  'use strict';

  if (window.cbBgnConverterInit) return;
  window.cbBgnConverterInit = true;

  var RATE = 1.95583;

  // Match common EUR price patterns:
  // €119,00 EUR / €41 EUR / €1.200,50 EUR / €119.00 EUR / €119,00
  var EUR_RE = /€\s?[\d.,]+(?:\s*EUR)?/g;

  // Extract numeric value from a matched EUR string
  function parseEur(str) {
    var cleaned = str.replace(/[€EUR\s]/gi, '');
    if (!cleaned) return NaN;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');

    if (lastComma > lastDot) {
      // European: 1.200,50
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      // English: 1,200.50
      cleaned = cleaned.replace(/,/g, '');
    }

    return parseFloat(cleaned);
  }

  // Format BGN amount: 232,74 лв.
  function formatBgn(amount) {
    var fixed = amount.toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return intPart + ',' + parts[1] + ' лв.';
  }

  // Process a single text node
  function processTextNode(node) {
    var text = node.textContent;
    if (!text || text.indexOf('€') === -1 || text.indexOf('лв.') !== -1) return;

    var newText = text.replace(EUR_RE, function (match) {
      var eur = parseEur(match);
      if (isNaN(eur) || eur <= 0) return match;
      return match + ' (' + formatBgn(eur * RATE) + ')';
    });

    if (newText !== text) {
      node.textContent = newText;
    }
  }

  // Walk all text nodes under a root element
  function walkTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) processTextNode(nodes[i]);
  }

  // Also handle elements where the price text is the element's own textContent
  // (Shopify sometimes puts €, amount, and EUR in separate child spans)
  function processElement(el) {
    // Skip if already has BGN
    if (el.dataset && el.dataset.cbBgn) return;
    var text = el.textContent;
    if (!text || text.indexOf('€') === -1 || text.indexOf('лв.') !== -1) return;

    // Only process leaf-like elements (no deeply nested structure)
    if (el.children.length > 3) return;

    // Check if combined textContent matches a EUR price
    var match = text.match(/€\s?[\d.,]+\s*EUR/);
    if (!match) return;

    var eur = parseEur(match[0]);
    if (isNaN(eur) || eur <= 0) return;

    // Append BGN as a new text node after the element's last child
    var bgnText = ' (' + formatBgn(eur * RATE) + ')';
    el.appendChild(document.createTextNode(bgnText));
    el.dataset.cbBgn = '1';
  }

  // Tags likely to contain prices
  var PRICE_TAGS = ['span', 'p', 'div', 'strong', 'b', 'del', 's', 'dd', 'td', 'li', 'a'];

  function convertAll() {
    // Pass 1: text nodes (handles simple cases)
    walkTextNodes(document.body);

    // Pass 2: elements where price spans across child nodes
    PRICE_TAGS.forEach(function (tag) {
      var els = document.getElementsByTagName(tag);
      for (var i = 0; i < els.length; i++) {
        processElement(els[i]);
      }
    });
  }

  // Debounced observer
  var timeout;
  function onMutation(mutations) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === Node.ELEMENT_NODE) {
            walkTextNodes(node);
            processElement(node);
            PRICE_TAGS.forEach(function (tag) {
              var children = node.getElementsByTagName(tag);
              for (var k = 0; k < children.length; k++) processElement(children[k]);
            });
          } else if (node.nodeType === Node.TEXT_NODE) {
            processTextNode(node);
          }
        }
      }
    }, 150);
  }

  function init() {
    // Small delay to ensure all Shopify scripts have rendered prices
    setTimeout(convertAll, 300);

    var observer = new MutationObserver(onMutation);
    observer.observe(document.body, { childList: true, subtree: true });

    window.cbBgnConverter = { refresh: convertAll };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
